export function downloadAccordion() {
  document.querySelectorAll('.dropdown-toggle').forEach(toggle => {
    toggle.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      if (targetElement.style.height) {
        targetElement.style.height = null;
        targetElement.style.opacity = 0;
      } else {
        targetElement.style.height = targetElement.scrollHeight + 'px';
        targetElement.style.opacity = 1;
      }
      this.classList.toggle('is-open');
    });
  });
}